"use client";

import localFont from "next/font/local";

import "@/styles/globals.css";

import { MainErrorFallback } from "@/components/errors/main";
import { cn } from "@/lib/utils";

const inter = localFont({
  display: "swap",
  src: "./fonts/Inter.woff2",
  variable: "--font-inter",
  weight: "100 900",
});

export default function GlobalError() {
  return (
    <html lang="en">
      <body
        className={cn(
          "ausd-text-body bg-ausd-background text-foreground font-sans not-italic antialiased",
          inter.variable,
        )}
      >
        <MainErrorFallback />
      </body>
    </html>
  );
}
